import api from "./api"

export interface DashboardStats {
  total_farmers: number
  total_trees: number
  total_tree_types: number
  active_regions: number
}

export const statsService = {
  async getDashboardStats(): Promise<DashboardStats> {
    const { data } = await api.get("/reports/stats")
    return data
  },
}
